module.exports = __webpack_public_path__ + "img/bth_tunbu_nor.2bd2c9c2.png";